import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Dropdown } from 'semantic-ui-react';
import {
  reAllocationInitialState,
  reAllocationTypes,
} from '../../../app/stores/CRMStore/types';
import { useStore } from '../../../app/stores/store';
import './ReallocationModal.css';

const ReallocationModal = ({isOpen, setIsOpen}:{isOpen:boolean,setIsOpen:any}) => {
  const { NFAI_Restoration_SmartflowsStore, userStore } = useStore();
  const { userList, loadUsers } = userStore;

  const [formErrors, setFormErrors] = useState({
    employeeId: false,
    startFrame: false,
    endFrame: false,
  });

  useEffect(() => {
    loadUsers();
    //eslint-disable-next-line
  }, []);

  const handleDisplayNameChange = (_: any, data: any) => {
    const selectedDisplayName = data.value;
    const matchedUser = userList.find(
      (user) => user.displayName === selectedDisplayName,
    );
    NFAI_Restoration_SmartflowsStore.subtaskCompoent.reAllocationList.userId =
      matchedUser?.id || '';
    NFAI_Restoration_SmartflowsStore.subtaskCompoent.reAllocationList.employeeId =
      selectedDisplayName;
    NFAI_Restoration_SmartflowsStore.subtaskCompoent.reAllocationList.employeeName =
      matchedUser?.username || '';

    // Clear error when valid
    setFormErrors((prev) => ({ ...prev, employeeId: false }));
  };

  const updateTotalFrame = (name: string, value: string) => {
    const sanitizedValue = value.replace(/^0+(?!$)/, '');

    if (name === 'startFrame') {
      NFAI_Restoration_SmartflowsStore.subtaskCompoent.reAllocationList.startFrame =
        sanitizedValue;

      if (sanitizedValue && !isNaN(Number(sanitizedValue))) {
        setFormErrors((prev) => ({ ...prev, startFrame: false }));
      }
    } else {
      NFAI_Restoration_SmartflowsStore.subtaskCompoent.reAllocationList.endFrame =
        sanitizedValue;

      if (sanitizedValue && !isNaN(Number(sanitizedValue))) {
        setFormErrors((prev) => ({ ...prev, endFrame: false }));
      }
    }

    const startNum = parseInt(
      NFAI_Restoration_SmartflowsStore.subtaskCompoent.reAllocationList
        .startFrame,
    );
    const endNum = parseInt(
      NFAI_Restoration_SmartflowsStore.subtaskCompoent.reAllocationList
        .endFrame,
    );

    const isValid = !isNaN(startNum) && !isNaN(endNum);
    const isPositiveRange = isValid && endNum >= startNum;

    const total = isPositiveRange ? (endNum - startNum + 1).toString() : '';

    NFAI_Restoration_SmartflowsStore.subtaskCompoent.reAllocationList.totalFrame =
      total;
  };

  const handleSave = () => {
    const { employeeId, startFrame, endFrame } =
      NFAI_Restoration_SmartflowsStore.subtaskCompoent.reAllocationList;

    const errors = {
      employeeId: !employeeId,
      startFrame: !startFrame || isNaN(Number(startFrame)),
      endFrame: !endFrame || isNaN(Number(endFrame)),
    };

    setFormErrors(errors);
    const temp =
      NFAI_Restoration_SmartflowsStore.subtaskCompoent.reAllocationList;
    const payload: reAllocationTypes = {
      ...reAllocationInitialState,
      itemId: temp.itemId || '',
      userId: temp.userId,
      employeeId: temp.employeeId,
      employeeName: temp.employeeName,
      startFrame: temp.startFrame,
      endFrame: temp.endFrame,
      totalFrame: temp.totalFrame,
    };

    NFAI_Restoration_SmartflowsStore.updateCutlistUserAllocation(payload);
    NFAI_Restoration_SmartflowsStore.subtaskCompoent.elements = [];
    NFAI_Restoration_SmartflowsStore.subtaskCompoent.elementCopy = [];
    setIsOpen(false);
  };
  return (
    <>
      {isOpen && (
        <div className="reallocation-modal-container">
          <div className="reallocation-modal">
            <h1 className="reallocation-modal-title">Reallocation</h1>
            <hr />

            <div className="reallocation-form">
              {/* Row 1 */}
              <div className="reallocation-form-row">
                <div className="reallocation-form-group">
                  <label>
                    Employee ID <span className="required">*</span>
                  </label>
                  <Dropdown
                    placeholder="Select Operator"
                    fluid
                    search
                    selection
                    name="empId"
                    value={
                      NFAI_Restoration_SmartflowsStore.subtaskCompoent
                        .reAllocationList.employeeId
                    }
                    onChange={handleDisplayNameChange as any}
                    options={userList.map((user: any, index: number) => ({
                      key: index,
                      text: user.displayName,
                      value: user.displayName,
                    }))}
                    className={formErrors.employeeId ? 'error-field' : ''}
                  />
                  {formErrors.employeeId && (
                    <span className="error-text">Required</span>
                  )}
                </div>

                <div className="reallocation-form-group">
                  <label>Employee Name</label>
                  <input
                    type="text"
                    name="empName"
                    value={
                      NFAI_Restoration_SmartflowsStore.subtaskCompoent
                        .reAllocationList.employeeName
                    }
                    readOnly
                  />
                </div>
              </div>

              {/* Row 2 */}
              <div className="reallocation-form-row">
                <div className="reallocation-form-group">
                  <label>
                    Start Frame <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="startFrame"
                    value={
                      NFAI_Restoration_SmartflowsStore.subtaskCompoent
                        .reAllocationList.startFrame
                    }
                    onChange={(e: any) =>
                      updateTotalFrame('startFrame', e.target.value)
                    }
                    className={formErrors.startFrame ? 'error-field' : ''}
                  />
                  {formErrors.startFrame && (
                    <span className="error-text">Valid number required</span>
                  )}
                </div>

                <div className="reallocation-form-group">
                  <label>
                    End Frame <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="endFrame"
                    value={
                      NFAI_Restoration_SmartflowsStore.subtaskCompoent
                        .reAllocationList.endFrame
                    }
                    onChange={(e: any) =>
                      updateTotalFrame('endFrame', e.target.value)
                    }
                    className={formErrors.endFrame ? 'error-field' : ''}
                  />
                  {formErrors.endFrame && (
                    <span className="error-text">Valid number required</span>
                  )}
                </div>
              </div>

              {/* Row 3 */}
              <div className="reallocation-form-row">
                <div className="reallocation-form-group">
                  <label>Total Frame</label>
                  <input
                    readOnly
                    type="text"
                    name="totalFrame"
                    value={
                      NFAI_Restoration_SmartflowsStore.subtaskCompoent
                        .reAllocationList.totalFrame
                    }
                  />
                </div>
              </div>
            </div>

            <button className="reallocation-modal-btn" onClick={handleSave}>
              Save
            </button>
            <button
              className="reallocation-close-btn"
              onClick={() => setIsOpen(false)}
              aria-label="Close Modal"
            >
              x
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default observer(ReallocationModal);
